/**
 * Returns a list of unique term types.
 *
 * @param {Term[]} terms - see src/services/terms
 * @returns {string[]}
 */
export function getTypes(terms) {
    const types = new Set();
    for (const term of terms) {
        types.add(term.type);
    }
    return Array.from(types);
}

/**
 * Sorts term types into a predetermined order. Unknown types will be appended
 * at the end.
 *
 * @param {string[]} termTypes
 * @returns {string[]}
 */
export function sortTypes(termTypes) {
    termTypes = termTypes.slice();
    const preferredOrder = [
        'foundation',
        'intermediate',
        'advanced',
        'mentorship',
    ];
    return termTypes.sort((a, b) => {
        const ai = preferredOrder.indexOf(a);
        const bi = preferredOrder.indexOf(b);
        if (ai >= 0) {
            return bi >= 0 ? ai - bi : -1;
        } else {
            return bi >= 0 ? 1 : 0;
        }
    });
}

export default {
    getTypes,
    sortTypes,
}



// WEBPACK FOOTER //
// ./src/utils/terms.js